<template>
  <event-list
    :extra="extra"
    :title="title"
    :types="types"
  ></event-list>
</template>

<script>
import EventList from '@/components/EventList'
import MetaInfoBuilder from '@/utils/social'
import { CookingWorkshopType, EventType, RetreatType, SupperClubType, oldEvents } from '@/views/events/events'

export default {
  components: {
    EventList,
  },
  data: () => ({
    extra: oldEvents
        .filter((_event) => _event.type === EventType.value),
    title: 'Events',
    types: [
      CookingWorkshopType.value,
      EventType.value,
      RetreatType.value,
      SupperClubType.value,
    ],
  }),
  metaInfo() {
    return new MetaInfoBuilder()
      .description(this.title)
      .title(this.title)
      .build()
  }
}
</script>
